import { Component, ContentChild, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Subject } from 'rxjs';
import { ActivityCriteria, ActivityType } from 'src/app/common';
import { Guid, setTimeout$, Utility } from 'src/app/core/common';
import { ActivityService } from 'src/app/services/activity.service';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {
  Utility = Utility;
  Guid = Guid;
  ActivityType = ActivityType;

  operators: any[];
  operator: any;
  activities: any[];
  total: number;
  criteria: ActivityCriteria = {};
  from: number = 0;
  @Input() user: string;
  @Input() job: string;
  @Input() rtwad: string;

  @Input() isDone: boolean;
  @Input() inline = false;
  @Input() compact = false;
  @Input() showAdd = true;
  @Input() type: string;
  @Input() limit?: number;
  @Input() data: any;
  @Output('done-click') doneClick = new EventEmitter<any>();
  @Output('title-click') titleClick = new EventEmitter<any>();

  @ViewChild('activityModal') activityModal: NgxSmartModalComponent;

  @ContentChild('data', { static: false }) dataTemplateRef: TemplateRef<any>;

  constructor(private store: Store, private route: ActivatedRoute, private router: Router,
    private activityService: ActivityService, private userService: UserService,
    private sharedService: SharedService) {

    this.operator = this.store.selectSnapshot(state => state.auth.user);

    this.operators = [this.operator];
    if (this.operator.IsOperator)
      this.userService.karpashas$.subscribe(_ => this.operators = _);

    this.sharedService.onEventBus('activity-refresh', async () => await this.load(), this.unsubscribe$);
  }
  async ngOnInit() {
    if (this.inline)
      await this.load()
    else
      this.sharedService.navigationEnd$.subscribe(async () => await this.load())

  }

	async ngOnChanges(changes: SimpleChanges) {
    if (this.inline && (changes.user || changes.job || changes.rtwad))
    	await this.load()
	}

  async refresh() {
    this.sharedService.eventBus.emit('activity-refresh');
  }

  isSystem(activity) { return activity.Key?.startsWith('system-'); }

  now = new Date();
  private async load() {
    this.now = new Date();

    this.criteria = {
      UserId: this.user || undefined,
      JobId: this.job || undefined,
			ReadyToWorkAdId: this.rtwad || undefined,
    };

    if (!this.inline) {
      let params = this.route.snapshot.queryParams;
      this.criteria = {
        ...this.criteria,
        Keyword: params.q,
        IsDone: params.all == 'true' ? undefined : false,
        ToDate: params.future == 'true' ? undefined : new Date(new Date().setHours(23, 59, 59, 999)),
        Type: params.type ? +params.type : undefined,
        UserId: this.user || undefined,
        JobId: this.job || undefined,
				ReadyToWorkAdId: this.rtwad || undefined,
        OperatorId: this.inline ? undefined : (params.opid || this.operator.Id),
        IncludeUserSummary: true
      };
      this.from = params.from || 0;
      this.limit = params.limit || 30;
    }

    var result = await this.activityService.search(this.criteria, this.from, this.limit);
    this.activities = result.List;
    this.total = result.Total;
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  _onUpdate: (activity: any) => void;
  open(activity: any, onUpdate?: (activity: any) => void) {
    if (!activity || this.isSystem(activity)) return;
    delete this.selected;
    setTimeout$(() => {
      this.selected = Utility.clone(activity);
      this.activityModal.open();
      this._onUpdate = onUpdate;
    });
  }

  selected: any = {};
  newActivity(isDone: boolean) {
    this.open({
      CreatorId: this.operator.Id,
      OperatorId: this.operator.Id,
      UserId: this.user,
      JobId: this.job,
			ReadyToWorkAdId: this.rtwad,
      IsDone: isDone,
      // DueDate: isDone ? undefined : new Date(Date.now() + DateConstants.oneHour)
    });
  }

  async onUpdate(done: boolean) {
    if (done) this.activityModal.close();
    if (this._onUpdate) this._onUpdate(this.selected);
    await this.load();
    await this.activityService.getToDo();
  }

  openDone(activity: any) {
    if (activity.IsDone) return;
    activity._mode = 'done';
    if (this.doneClick.observers?.length)
      this.doneClick.emit(Utility.clone(activity));
    else this.open(activity);
  }
  openEdit(activity: any) {
    activity._mode = 'edit';
    activity._done = activity.IsDone;
    this.open(activity);
  }

  navigate(key: string, value: any) {
    let params = { ...this.route.snapshot.queryParams };
    params['from'] = 0;
    params[key] = value;
    this.router.navigate([], { queryParams: params, queryParamsHandling: 'merge', relativeTo: this.route });
  }
}
//TODO:3 UI for karpasha and Guide
//TODO:3 available as popup?
